import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountCompaniesQueryKey, accountQueryKey } from "../account.keys";

type Company = Dtos.Admin.SuretyAccount.Get.Response["companies"][number];

export const useAdminRunCompanyCreditReport = (accountId: SuretyAccountId) => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async (company: Company) => {
			const body: Dtos.Admin.CompanyCreditReport.Create.Request = {
				companyContactId: company.id,
				name: company.name,
				address: company.address,
				fein: company.fein,
			};
			return post<Dtos.Admin.CompanyCreditReport.Create.Response>(
				`/v2/admin/surety/accounts/${accountId}/companies/credit-report`,
				body,
			);
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountCompaniesQueryKey(accountId) }),
			]);
		},
	});

	return {
		runCompanyCreditReport: mutation.mutate,
		runCompanyCreditReportPending: mutation.isPending,
		runCompanyCreditReportError: mutation.error,
		dismissRunCompanyCreditReportError: () => {
			mutation.reset();
		},
	};
};
